import { render } from "./CourseTime.vue?vue&type=template&id=84735750&scoped=true"
import script from "./CourseTime.vue?vue&type=script&lang=js"
export * from "./CourseTime.vue?vue&type=script&lang=js"

import "./CourseTime.vue?vue&type=style&index=0&id=84735750&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84735750"]])

export default __exports__